import { Field } from '@/layout/field'

export default class FieldRow extends Field {
  subfields = []

  constructor (subfields = []) {
    super({ subfields })
    this.subfields = subfields
  }

  getSubfields () {
    return this.subfields
  }
}
